import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {Alert, Badge, Card, Col, Row, Spinner, Button} from "react-bootstrap";
import {reportsApi} from "../../../../api/reports.js";
import {ReportPageShell, DateRangeFilter} from "./ReportLayout.jsx";
import {exportTableToCsv, openTablePrintWindow} from "./exportUtils.js";

function AdminRevenueReportPage() {
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const load = async () => {
        setLoading(true);
        setError("");
        try {
            const resp = await reportsApi.getRevenueReport({dateFrom, dateTo});
            setData(resp);
        } catch (e) {
            console.error(e);
            setError("Failed to load revenue report.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, []);

    return (
        <ReportPageShell title="Revenue Summary" subtitle="Totals, fees, and tax over a selected range.">
            <DateRangeFilter
                dateFrom={dateFrom}
                dateTo={dateTo}
                onChange={(field, val) => field === "dateFrom" ? setDateFrom(val) : setDateTo(val)}
                onApply={load}
            />
            {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            {loading && (
                <div className="d-flex align-items-center my-4">
                    <Spinner animation="border" size="sm" className="me-2" />
                    <span>Loading...</span>
                </div>
            )}
            {!loading && data && (
                <Card className="dashboard-panel mt-3" id="revenue-table">
                    <Card.Header className="bg-white d-flex justify-content-between align-items-center">
                        <strong>Summary</strong>
                        <div className="d-flex gap-2">
                            <Button size="sm" variant="outline-secondary" onClick={() => exportTableToCsv("revenue-table", "revenue.csv")}>Export CSV</Button>
                            <Button size="sm" variant="outline-secondary" onClick={() => openTablePrintWindow("revenue-table")}>Export PDF</Button>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <Row className="g-3 text-center">
                            <Col md={3}>
                                <div className="small text-muted">Orders</div>
                                <div className="h4">{data.totalOrders}</div>
                            </Col>
                            <Col md={3}>
                                <div className="small text-muted">Revenue</div>
                                <div className="h5">${data.totalRevenue.toFixed(2)}</div>
                            </Col>
                            <Col md={3}>
                                <div className="small text-muted">Product Fees</div>
                                <div className="h6">${data.totalProductFees.toFixed(2)}</div>
                            </Col>
                            <Col md={3}>
                                <div className="small text-muted">Service Fees</div>
                                <div className="h6">${data.totalServiceFees.toFixed(2)}</div>
                            </Col>
                        </Row>
                        <Row className="g-3 text-center mt-3">
                            <Col md={3}>
                                <div className="small text-muted">Tax</div>
                                <div className="h6">${data.totalTax.toFixed(2)}</div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            )}
        </ReportPageShell>
    );
}

export default observer(AdminRevenueReportPage);
